module.exports = __webpack_public_path__ + "img/gold-logo.4c36f0b2.png";